module.exports = __webpack_public_path__ + "fe9dd475ca5ef23165b6b7279ddd8f22.pdf";